import React from 'react';

import LogoImage from '../../assets/logo.png';
import LogoWhiteImage from '../../assets/logo-white.png';

import './style.scss';

class Logo extends React.Component {
  render() {
    return (
      <div className="assessment__logo">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <img
                alt="Paragon One"
                src={this.props.white ? LogoWhiteImage : LogoImage}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Logo;



// WEBPACK FOOTER //
// ./src/routes/assessment/components/Logo/index.js